import React, { useState } from 'react';
import {resendSignUpCode } from "@aws-amplify/auth"

const ResendConfirmation: React.FC = () => {
  const [username, setUsername] = useState<string>("");
  const [message, setMessage] = useState<string>("");

  const handleResendConfirmation = async () => {
    try {
      await resendSignUpCode({username});
      setMessage("Confirmation code resent successfully");
    } catch (error) {
      console.error('Error resending confirmation code:', error);
      setMessage("Failed to resend confirmation code");
    }
  };
  return (
    <div>
      <h1>Resend Confirmation</h1>
      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <button onClick={handleResendConfirmation}>Resend Confirmation Code</button>
      <p>{message}</p>
    </div>
  );
}

export default ResendConfirmation;
